import { createReducer } from 'utils/redux'

const defaultState = {
  workspaces: {},
}

// Workspaces
const receiveLocalWorkspacesHandler = ({ draft, action }) => {
  const workspaces = action.payload
  const workspacesById = workspaces.reduce((workspacesById, workspace) => {
    workspacesById[workspace.id] = workspace
    return workspacesById
  }, {})

  draft.workspaces = workspacesById
}

const receiveUpdatedWorkspaceHandler = ({ draft, action }) => {
  draft.workspaces[action.payload.id] = action.payload
}

const actions = {
  RECEIVE_LOCAL_WORKSPACES: receiveLocalWorkspacesHandler,
  RECEIVE_UPDATED_WORKSPACE: receiveUpdatedWorkspaceHandler,
}

const workspacesReducer = createReducer(defaultState, actions)

export default workspacesReducer
